import React, { useEffect, useState } from "react";
import { Card } from "@material-ui/core";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import Google from "../SocialLogin/Google";
import Facebook from "../SocialLogin/Facebook";
import Apple from "../SocialLogin/Apple";
import { useForm } from "react-hook-form";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { toast } from 'react-toastify';

const ProfileSocialMedia = ({ emails, loadEmails }) => {
    // const { enqueueSnackbar } = useSnackbar();
    const [saving, setSaving] = useState(false);
    const [sending, setSending] = useState(false);
    const [googleUrl, setGoogleUrl] = useState();
    const [facebookUrl, setFacebookUrl] = useState();
    const {
        register,
        formState: { errors },
        handleSubmit,
        setError,
        setValue,
        getValues,
        watch,
    } = useForm();

    const [anyChange, setAnyChange] = useState(true);
    useEffect(() => {
        ApiService.get('/auth/social/google').then(({ data }) => {
            setGoogleUrl(data)
        })
        ApiService.get('/auth/social/facebook').then(({ data }) => {
            setFacebookUrl(data)
        })
    }, [])

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (type == "change" || type == "click") {
                setAnyChange(false);
            }
        });
        return () => { };
    }, [watch]);

    useEffect(() => {
        if (emails) {
            emails.forEach((email) => {
                setValue(email.Platform, email.Email);
            });
        }
    }, [emails]);

    const onSubmit = (body) => {
        setSaving(true);
        ApiService.post("/updateSocialEmails", body)
            .then((data) => {
                setSaving(false);
                loadEmails()
                toast.success("Success")
                // enqueueSnackbar("success", { variant: "success" });
            })
            .catch(({ data }) => {
                if (data.errors) {
                    Object.entries(data.errors).forEach((value) => {
                        setError(value[0], { message: value[1] });
                    });
                }
                setSaving(false);
            });
    };

    let openChild = (platform) => {
        let urlPop = googleUrl;
        if (platform == 'facebook') {
            urlPop = facebookUrl
        }
        var popup = window.open(urlPop, 'myPopup', 'width=500,height=500');
        var timer = setInterval(function () {
            if (popup.closed) {
                clearInterval(timer);
            }
        }, 1000);

        window.addEventListener("message", function (event) {
            if (!sending) {
                if (event.data.source && (event.data.source == 'react-devtools-bridge' || event.data.source == 'react-devtools-content-script')) {
                    return;
                }
                if (JSON.parse(event.data).email) {
                    setSending(true)
                    onSubmit({
                        google: JSON.parse(event.data).email
                    })
                }
            }
        });

    }
    return (
        <Card className="shadow p-3">
            <h6 className="fs-5 fw-500 mt-2 mb-4">Social Media Links</h6>
            {emails && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container
                        spacing={2}
                        columns={{ xs: 3, sm: 3, md: 3 }}>
                        <Grid item xs={2}
                            sm={1}
                            md={1}
                            padding="8px 0px 0px 0px">
                            <div className="d-flex">
                                <TextField
                                    {...register("google")}
                                    fullWidth
                                    disabled
                                    color="secondary"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Google />
                                            </InputAdornment>
                                        ),
                                    }}
                                    label="Google"

                                />
                            </div>
                            {errors.google && (
                                <p style={{ color: "red" }} className="px-1">
                                    {errors.google?.message}
                                </p>
                            )}
                        </Grid>
                        <Grid item xs={2}
                            sm={1}
                            md={1}
                            padding="8px 0px 0px 16px">
                            <TextField
                                {...register("facebook")}
                                fullWidth
                                disabled
                                color="secondary"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Facebook />
                                        </InputAdornment>
                                    ),
                                }}
                                label="Facebook"
                            />
                            {errors.facebook && (
                                <p style={{ color: "red" }} className="px-1">
                                    {errors.facebook?.message}
                                </p>
                            )}
                        </Grid>
                        <Grid item xs={2}
                            sm={1}
                            md={1}
                            padding="8px 0px 0px 16px">
                            <TextField
                                {...register("apple")}
                                fullWidth
                                disabled
                                color="secondary"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Apple fill="black" />
                                        </InputAdornment>
                                    ),
                                }}
                                label="Apple"
                            />
                            {errors.apple && (
                                <p style={{ color: "red" }} className="px-1">
                                    {errors.apple?.message}
                                </p>
                            )}
                        </Grid>
                    </Grid>
                </form>
            )}

            {!emails && (
                <Grid className="placeholder-glow" container >
                    <Grid item sm={3} padding="10px">
                        <span
                            className="placeholder col-12"
                            style={{ height: "60px" }}
                        ></span>
                    </Grid>
                    <Grid item sm={3} padding="10px">
                        <span
                            className="placeholder col-12"
                            style={{ height: "60px" }}
                        ></span>
                    </Grid>
                    <Grid item sm={3} padding="10px">
                        <span
                            className="placeholder col-12"
                            style={{ height: "60px" }}
                        ></span>
                    </Grid>
                </Grid>
            )}
        </Card>
    );
};

export default ProfileSocialMedia;
